import ResourceApi from '../ResourceApi';

const ObjectiveResource = {
  getTrashed: async (userId) => (await ResourceApi.get(`/resource/objectives/trashed?user_id=${userId}`)).data,
  restore: async (id) => (await ResourceApi.get(`/resource/objectives/${id}/restore`)).data,
  delete: async (id, params = {}) => (await ResourceApi.destroy(`/resource/objectives/${id}`, params)).data,
};

export default ObjectiveResource;
